import type { z } from "zod";

function createCodec<TApi, TApp>(config: {
  apiSchema: z.ZodType<TApi>;
  deserialize: (api: TApi) => TApp;
  serialize: (app: TApp) => TApi;
}) {
  const schema = config.apiSchema.transform(config.deserialize);

  return {
    apiSchema: config.apiSchema,
    schema,
    decode: (raw: unknown): TApp => schema.parse(raw),
    encode: config.serialize,
  };
}

type Codec = ReturnType<typeof createCodec>;

export { createCodec, type Codec };
